"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildGroup = exports.groupControl = exports.arrayControl = exports.control = exports.GroupControl = exports.ArrayControl = exports.ParentControl = exports.FormControl = exports.BaseControl = exports.ControlChange = exports.ControlFlags = void 0;
var ControlFlags;
(function (ControlFlags) {
    ControlFlags[ControlFlags["Valid"] = 1] = "Valid";
    ControlFlags[ControlFlags["Touched"] = 2] = "Touched";
    ControlFlags[ControlFlags["Dirty"] = 4] = "Dirty";
    ControlFlags[ControlFlags["Disabled"] = 8] = "Disabled";
})(ControlFlags = exports.ControlFlags || (exports.ControlFlags = {}));
var ControlChange;
(function (ControlChange) {
    ControlChange[ControlChange["Valid"] = 1] = "Valid";
    ControlChange[ControlChange["Touched"] = 2] = "Touched";
    ControlChange[ControlChange["Dirty"] = 4] = "Dirty";
    ControlChange[ControlChange["Disabled"] = 8] = "Disabled";
    ControlChange[ControlChange["Value"] = 16] = "Value";
    ControlChange[ControlChange["Error"] = 32] = "Error";
    ControlChange[ControlChange["All"] = 63] = "All";
    ControlChange[ControlChange["Validate"] = 64] = "Validate";
})(ControlChange = exports.ControlChange || (exports.ControlChange = {}));
var controlCount = 0;
var BaseControl = /** @class */ (function () {
    function BaseControl() {
        this.flags = ControlFlags.Valid;
        this.uniqueId = ++controlCount;
        this.element = null;
        /**
         * @internal
         */
        this.listeners = [];
        this.stateVersion = 0;
        /**
         * @internal
         */
        this.freezeCount = 0;
        /**
         * @internal
         */
        this.frozenChanges = 0;
    }
    /**
     * @internal
     */
    BaseControl.prototype.updateError = function (error) {
        if (this.error !== error) {
            this.error = error;
            return ControlChange.Error | this.updateValid(!Boolean(error));
        }
        return this.updateValid(!Boolean(error));
    };
    Object.defineProperty(BaseControl.prototype, "valid", {
        get: function () {
            return Boolean(this.flags & ControlFlags.Valid);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControl.prototype, "dirty", {
        get: function () {
            return Boolean(this.flags & ControlFlags.Dirty);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControl.prototype, "disabled", {
        get: function () {
            return Boolean(this.flags & ControlFlags.Disabled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseControl.prototype, "touched", {
        get: function () {
            return Boolean(this.flags & ControlFlags.Touched);
        },
        enumerable: false,
        configurable: true
    });
    BaseControl.prototype.setFlag = function (flag, b) {
        this.flags = b ? this.flags | flag : this.flags & ~flag;
    };
    /**
     * @internal
     */
    BaseControl.prototype.updateValid = function (valid) {
        if (this.valid !== valid) {
            this.setFlag(ControlFlags.Valid, valid);
            return ControlChange.Valid;
        }
        return 0;
    };
    /**
     * @internal
     */
    BaseControl.prototype.updateDisabled = function (disabled) {
        if (this.disabled !== disabled) {
            this.setFlag(ControlFlags.Disabled, disabled);
            return ControlChange.Disabled;
        }
        return 0;
    };
    /**
     * @internal
     */
    BaseControl.prototype.updateDirty = function (dirty) {
        if (this.dirty !== dirty) {
            this.setFlag(ControlFlags.Dirty, dirty);
            return ControlChange.Dirty;
        }
        return 0;
    };
    /**
     * @internal
     */
    BaseControl.prototype.updateTouched = function (touched) {
        if (this.touched !== touched) {
            this.setFlag(ControlFlags.Touched, touched);
            return ControlChange.Touched;
        }
        return 0;
    };
    /**
     * @internal
     */
    BaseControl.prototype.runListeners = function (changed) {
        var _this = this;
        this.frozenChanges = 0;
        this.stateVersion++;
        this.listeners.forEach(function (_a) {
            var m = _a[0], cb = _a[1];
            if ((m & changed) !== 0)
                cb(_this, changed);
        });
    };
    /**
     * @internal
     */
    BaseControl.prototype.runChange = function (changed) {
        if (changed) {
            if (this.freezeCount === 0) {
                this.runListeners(changed);
            }
            else {
                this.frozenChanges |= changed;
            }
        }
        return this;
    };
    /**
     * @internal
     */
    BaseControl.prototype.groupedChanges = function (run) {
        this.freezeCount++;
        run();
        this.freezeCount--;
        if (this.freezeCount === 0 && this.frozenChanges) {
            this.runListeners(this.frozenChanges);
        }
        return this;
    };
    BaseControl.prototype.addChangeListener = function (listener, mask) {
        this.listeners = __spreadArrays(this.listeners, [
            [mask ? mask : ControlChange.All, listener],
        ]);
    };
    BaseControl.prototype.removeChangeListener = function (listener) {
        this.listeners = this.listeners.filter(function (cl) { return cl[1] !== listener; });
    };
    BaseControl.prototype.setError = function (error) {
        return this.runChange(this.updateError(error));
    };
    /**
     * Run validation listeners.
     */
    BaseControl.prototype.validate = function () {
        return this.runChange(ControlChange.Validate);
    };
    return BaseControl;
}());
exports.BaseControl = BaseControl;
function setValueUnsafe(ctrl, v, initial) {
    ctrl.setValue(v, initial);
}
var FormControl = /** @class */ (function (_super) {
    __extends(FormControl, _super);
    function FormControl(value, validator) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.initialValue = value;
        if (validator !== null) {
            _this.setError(validator === null || validator === void 0 ? void 0 : validator(value));
            _this.addChangeListener(function () {
                var error = validator === null || validator === void 0 ? void 0 : validator(_this.value);
                _this.runChange(_this.updateError(error));
            }, ControlChange.Value | ControlChange.Validate);
        }
        return _this;
    }
    FormControl.prototype.toValue = function () {
        return this.value;
    };
    /**
     * Set the value for this control and
     * update the dirty flag if changed.
     * @param value The value to set
     * @param initial If true the dirty flag is reset
     * and a copy of the value is kept to check for dirtiness
     * on any future updates.
     */
    FormControl.prototype.setValue = function (value, initial) {
        if (value !== this.value) {
            this.value = value;
            if (initial) {
                this.initialValue = value;
            }
            this.runChange(ControlChange.Value | this.updateDirty(value !== this.initialValue));
        }
        else if (initial) {
            this.initialValue = value;
            this.runChange(this.updateDirty(false));
        }
        return this;
    };
    FormControl.prototype.markAsClean = function () {
        this.initialValue = this.value;
        this.runChange(this.updateDirty(false));
    };
    FormControl.prototype.visitChildren = function (visit, doSelf, recurse) {
        return !doSelf || visit(this);
    };
    /**
     * Set the disabled flag.
     * @param disabled
     */
    FormControl.prototype.setDisabled = function (disabled) {
        this.runChange(this.updateDisabled(disabled));
        return this;
    };
    /**
     * Set the touched flag.
     * @param touched
     */
    FormControl.prototype.setTouched = function (touched) {
        this.runChange(this.updateTouched(touched));
        return this;
    };
    return FormControl;
}(BaseControl));
exports.FormControl = FormControl;
var ParentControl = /** @class */ (function (_super) {
    __extends(ParentControl, _super);
    function ParentControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @internal
     */
    ParentControl.prototype.updateAll = function (change) {
        this.visitChildren(function (c) {
            c.runChange(change(c));
            return true;
        }, true, true);
    };
    /**
     * @internal
     */
    ParentControl.prototype.parentListener = function () {
        var _this = this;
        return [
            ControlChange.Value |
                ControlChange.Valid |
                ControlChange.Touched |
                ControlChange.Dirty,
            function (child, change) {
                var flags = change & ControlChange.Value;
                if (change & ControlChange.Valid) {
                    var valid = child.valid && (_this.valid || _this.visitChildren(function (c) { return c.valid; }));
                    flags |= _this.updateValid(valid);
                }
                if (change & ControlChange.Dirty) {
                    var dirty = child.dirty || _this.selfDirty() || (_this.dirty && !_this.visitChildren(function (c) { return !c.dirty; }));
                    flags |= _this.updateDirty(dirty);
                }
                if (change & ControlChange.Touched) {
                    flags |= _this.updateTouched(child.touched || _this.touched);
                }
                _this.runChange(flags);
            },
        ];
    };
    ParentControl.prototype.selfDirty = function () {
        return false;
    };
    /**
     * @internal
     */
    ParentControl.prototype.controlFromDef = function (cdef) {
        var l = this.parentListener();
        var child = cdef();
        child.addChangeListener(l[1], l[0]);
        l[1](child, ControlChange.All);
        return child;
    };
    /**
     * Set the disabled flag on this and all children.
     * @param disabled
     */
    ParentControl.prototype.setDisabled = function (disabled) {
        this.updateAll(function (c) { return c.updateDisabled(disabled); });
        return this;
    };
    /**
     * Set the touched flag on this and any children.
     * @param touched
     */
    ParentControl.prototype.setTouched = function (touched) {
        this.updateAll(function (c) { return c.updateTouched(touched); });
        return this;
    };
    /**
     * Run validation listeners for this and any children.
     */
    ParentControl.prototype.validate = function () {
        this.updateAll(function () { return ControlChange.Validate; });
        return this;
    };
    /**
     * Clear all error messages and mark controls as valid.
     */
    ParentControl.prototype.clearErrors = function () {
        this.updateAll(function (c) { return c.updateError(undefined); });
        return this;
    };
    /**
     * Lookup a child control give an array of control path elements.
     * A path element is either a string property name for GroupControl
     * or an index number for ArrayControl.
     * @param path
     */
    ParentControl.prototype.lookupControl = function (path) {
        var base = this;
        var index = 0;
        while (index < path.length && base) {
            var childId = path[index];
            if (base instanceof GroupControl) {
                base = base.fields[childId];
            }
            else if (base instanceof ArrayControl && typeof childId == "number") {
                base = base.elems[childId];
            }
            else {
                return null;
            }
            index++;
        }
        return base;
    };
    return ParentControl;
}(BaseControl));
exports.ParentControl = ParentControl;
var ArrayControl = /** @class */ (function (_super) {
    __extends(ArrayControl, _super);
    function ArrayControl(childDefinition) {
        var _this = _super.call(this) || this;
        _this.childDefinition = childDefinition;
        _this.elems = [];
        _this.initialFields = [];
        return _this;
    }
    /**
     * Set the child values. Underlying controls will be
     * added/deleted if the size of the array changes.
     * @param value The values to set on child controls
     * @param initial If true reset the dirty flag
     */
    ArrayControl.prototype.setValue = function (value, initial) {
        var _this = this;
        value = value !== null && value !== void 0 ? value : [];
        return this.groupedChanges(function () {
            var flags = 0;
            var childElems = __spreadArrays(_this.elems);
            if (childElems.length !== value.length) {
                flags |= ControlChange.Value;
            }
            value.map(function (v, i) {
                if (childElems.length <= i) {
                    var newControl = _this.controlFromDef(_this.childDefinition);
                    setValueUnsafe(newControl, v, true);
                    childElems.push(newControl);
                }
                else {
                    setValueUnsafe(childElems[i], v, initial);
                }
            });
            var targetLength = value.length;
            var actualLength = childElems.length;
            if (targetLength !== actualLength) {
                childElems.splice(targetLength, actualLength - targetLength);
            }
            _this.elems = childElems;
            if (initial) {
                _this.initialFields = childElems;
                flags |= _this.updateDirty(false);
            }
            else {
                flags |= _this.updateDirty(_this.selfDirty() ||
                    !_this.visitChildren(function (c) { return !c.dirty; }));
            }
            _this.runChange(flags);
        });
    };
    ArrayControl.prototype.markAsClean = function () {
        var _this = this;
        return this.groupedChanges(function () {
            _this.runChange(_this.updateDirty(false));
            _this.initialFields = _this.elems;
            _this.elems.forEach(function (c) { return c.markAsClean(); });
        });
    };
    ArrayControl.prototype.toArray = function () {
        return this.elems.map(function (e) { return e.toValue(); });
    };
    ArrayControl.prototype.toValue = function () {
        return this.toArray();
    };
    ArrayControl.prototype.visitChildren = function (visit, doSelf, recurse) {
        if (doSelf && !visit(this)) {
            return false;
        }
        if (!this.elems.every(visit)) {
            return false;
        }
        if (recurse) {
            return this.elems.every(function (c) { return c.visitChildren(visit, false, true); });
        }
        return true;
    };
    /**
     * Add a new element to the array
     * @param index Optional insertion index
     */
    ArrayControl.prototype.add = function (index) {
        var newCtrl = this.controlFromDef(this.childDefinition);
        this.elems = __spreadArrays(this.elems);
        if (index !== undefined) {
            this.elems.splice(index, 0, newCtrl);
        }
        else {
            this.elems.push(newCtrl);
        }
        this.runChange(ControlChange.Value | this.updateArrayFlags());
        return newCtrl;
    };
    /**
     * Update the form elements and check flags.
     * @param f A function which takes the array of form elements and a function which
     * can create new elements and returns a new array.
     */
    ArrayControl.prototype.update = function (f) {
        var _this = this;
        var newElems = f(this.elems, function (v) {
            var ctrl = _this.controlFromDef(_this.childDefinition);
            setValueUnsafe(ctrl, v);
            return ctrl;
        });
        if (this.elems !== newElems) {
            this.elems = newElems;
            this.runChange(ControlChange.Value | this.updateArrayFlags());
        }
    };
    /**
     * Remove an element in the array by index
     * @param index The index of the form element to remove
     */
    ArrayControl.prototype.remove = function (index) {
        this.elems = this.elems.filter(function (e, i) { return i !== index; });
        return this.runChange(ControlChange.Value | this.updateArrayFlags());
    };
    ArrayControl.prototype.shallowEquals = function (a, b) {
        if (a.length !== b.length) {
            return false;
        }
        return !a.some(function (v, i) { return v !== b[i]; });
    };
    ArrayControl.prototype.selfDirty = function () {
        return !this.shallowEquals(this.elems, this.initialFields);
    };
    ArrayControl.prototype.updateArrayFlags = function () {
        return (this.updateTouched(true) |
            this.updateDirty(this.selfDirty() ||
                !this.visitChildren(function (c) { return !c.dirty; })) |
            this.updateValid(this.visitChildren(function (c) { return c.valid; })));
    };
    return ArrayControl;
}(ParentControl));
exports.ArrayControl = ArrayControl;
var GroupControl = /** @class */ (function (_super) {
    __extends(GroupControl, _super);
    function GroupControl(children) {
        var _this = _super.call(this) || this;
        _this.fields = {};
        _this.addFields(children);
        return _this;
    }
    GroupControl.prototype.addFields = function (moreChildren) {
        this.fields = __assign(__assign({}, this.fields), moreChildren);
        var l = this.parentListener();
        for (var c in moreChildren) {
            moreChildren[c].addChangeListener(l[1], l[0]);
        }
        this.setFlag(ControlFlags.Valid, this.visitChildren(function (c) { return c.valid; }));
        return this;
    };
    GroupControl.prototype.visitChildren = function (visit, doSelf, recurse) {
        if (doSelf && !visit(this)) {
            return false;
        }
        var fields = this.fields;
        for (var k in fields) {
            if (!visit(fields[k])) {
                return false;
            }
            if (recurse && !fields[k].visitChildren(visit, false, true)) {
                return false;
            }
        }
        return true;
    };
    /**
     * Set the value of all child controls.
     * If the child type contains `undefined` the fields is optional.
     * @param value The value for all child controls
     * @param initial If true reset the dirty flag
     */
    GroupControl.prototype.setValue = function (value, initial) {
        var _this = this;
        value = value !== null && value !== void 0 ? value : {};
        return this.groupedChanges(function () {
            var fields = _this.fields;
            for (var k in fields) {
                setValueUnsafe(fields[k], value[k], initial);
            }
        });
    };
    GroupControl.prototype.markAsClean = function () {
        var _this = this;
        return this.groupedChanges(function () {
            _this.runChange(_this.updateDirty(false));
            var fields = _this.fields;
            for (var k in fields) {
                fields[k].markAsClean();
            }
        });
    };
    GroupControl.prototype.toObject = function () {
        var rec = {};
        for (var k in this.fields) {
            var bctrl = this.fields[k];
            rec[k] = bctrl.toValue();
        }
        return rec;
    };
    GroupControl.prototype.toValue = function () {
        return this.toObject();
    };
    return GroupControl;
}(ParentControl));
exports.GroupControl = GroupControl;
/**
 * Define a form control containing values of type V
 * @param value Initial value for control
 * @param validator An optional synchronous validator
 */
function control(value, validator) {
    return function () { return new FormControl(value, validator); };
}
exports.control = control;
function makeCreator(v) {
    if (typeof v === "function") {
        return v;
    }
    return function () { return new FormControl(v); };
}
function arrayControl(child) {
    return function () { return new ArrayControl(makeCreator(child)); };
}
exports.arrayControl = arrayControl;
/**
 *
 * @param children
 */
function groupControl(children) {
    return function () {
        var fields = {};
        for (var k in children) {
            fields[k] = makeCreator(children[k])();
        }
        return new GroupControl(fields);
    };
}
exports.groupControl = groupControl;
/**
 * Create a form group function which only accepts
 * valid definitions that will produce values of given type T.
 */
function buildGroup() {
    return groupControl;
}
exports.buildGroup = buildGroup;
